import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';
import LeaseExpirationReminderForm from './lease_expiration_reminder_form';
import listingPropTypes from 'components/listing/prop_types';

export const leaseRateUnitsLabels = {
  dollars_per_sf_per_year: '$/SF/year',
  dollars_per_acre_per_year: '$/Acre/year',
  dollars_per_year: 'Annual Rent',
  dollars_per_acre_per_month: '$/Acre/month',
  dollars_per_month: 'Monthly'
};

export const leaseTermUnitsLabels = { months: 'Months', years: 'Years' };

export const spaceSizeUnitsLabels = { sf: 'SF', acres: 'Acres' };

export default class ListingLeaseInfo extends React.Component {
  static propTypes = {
    fieldsRequired: PropTypes.bool,
    listing: listingPropTypes.isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.props.onChange({ [name]: value });
  }

  render() {
    const { leaseDate, leaseTerm, leaseTermUnits, renewalReminder } = this.props.listing;
    const labels = [];
    if (!leaseDate) labels.push("Lease Begins");
    if (!leaseTerm) labels.push("Lease Term");
    if (!leaseTermUnits) labels.push("Lease Term Units");

    return (
      <React.Fragment>
        <h6>Description of Lease</h6>
        {this.renderLeaseInfo()}

        <LeaseExpirationReminderForm
          disabled={!(leaseDate && leaseTerm && leaseTermUnits)}
          disabledTooltip={`${labels.join(', ')} required to set reminder`}
          renewalReminder={renewalReminder}
          onChange={this.props.onChange}
        />
      </React.Fragment>
    );
  }

  renderLeaseInfo() {
    const { fieldsRequired, listing } = this.props;
    const { leaseDate, leaseRate, leaseTerm, spaceSize } = listing;
    const requiredClass = fieldsRequired ? 'required' : '';

    return <React.Fragment>
      <div className={`form-group ${requiredClass}`}>
        <label className="form-label">Space Size</label>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            name="spaceSize"
            required={fieldsRequired}
            type="number"
            value={spaceSize}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className={`form-group ${requiredClass}`}>
        <label className="form-label">Space Size Units</label>
        <div className="d-flex gap-3 flex-wrap">
          {this.renderInlineRadioButtons(spaceSizeUnitsLabels, 'spaceSizeUnits', fieldsRequired)}
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Lease Rate</label>
        <div className="form-input-container">
          <ManagedInput
            allowEmpty
            className="form-control"
            name="leaseRate"
            type="currency"
            value={leaseRate}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Lease Rate Units</label>
        <div className="d-flex gap-3 flex-wrap">
          {this.renderInlineRadioButtons(leaseRateUnitsLabels, 'leaseRateUnits')}
        </div>
      </div>

      <h6>Terms of Lease</h6>

      <div className={`form-group ${requiredClass}`}>
        <label className="form-label">Lease Term</label>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            name="leaseTerm"
            required={fieldsRequired}
            type="number"
            value={leaseTerm}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className={`form-group ${requiredClass}`}>
        <label className="form-label">Lease Term Units</label>
        <div className="d-flex gap-3 flex-wrap">
          {this.renderInlineRadioButtons(leaseTermUnitsLabels, 'leaseTermUnits', fieldsRequired)}
        </div>
      </div>

      <div className={`form-group ${requiredClass}`}>
        <label className="form-label">Lease Begins</label>
        <div className="form-input-container datepicker-full-width">
          <ManagedInput
            className="pe-2 form-control"
            name="leaseDate"
            required={fieldsRequired}
            type="date"
            value={leaseDate}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    </React.Fragment>;
  }

  renderInlineRadioButtons(labelsByValue, name, required) {
    return (
      <React.Fragment>
        {Object.keys(labelsByValue).map((value, i) => (
          <Form.Check id={`${name}_${value}`} key={i} type="radio">
            <Form.Check.Input
              checked={this.props.listing[name] === value}
              name={name}
              required={required}
              type="radio"
              value={value}
              onChange={this.handleChange}
            />
            <Form.Check.Label>{labelsByValue[value]}</Form.Check.Label>
          </Form.Check>
        ))}
      </React.Fragment>
    );
  }
}
